import React from 'react'
import { useParams, Navigate } from "react-router-dom";

const validBranches = [
  "lps-school-eldeco",
  "lps-school-ansal",
  "lps-school-ahiyaraipur",
  "lps-school-sector-d",
  "lps-school-sector-i",
  "lps-school-unnao-sector-b",
  "lps-school-unnao-sector-c",
  "lps-school-south-city",
  "lps-school-pragatipuram",
  "lps-school-jankipuram"
];

export default function BranchGuard({ children }) {
  const { branch_name } = useParams();

  if (!validBranches.includes(branch_name)) {
    return <Navigate to="/404" replace />;
  }

  return children;
}